import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    left: -8px;\n    position: absolute;\n    top: -8px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
export var StyledStepper = styled.div(_templateObject(), function (props) {
  return "\n        display: flex;\n        font-family: ".concat(props.theme.components.stepper.fontFamily, ";\n        vertical-align: middle;\n        ").concat(props.justifyContent ? "justify-content: ".concat(props.justifyContent, ";") : '', "\n    ");
});
export var StyledStepsText = styled.div(_templateObject2(), function (props) {
  return "\n        text-align: right;\n        margin-top: ".concat(props.isFinalStep ? '18px' : '11px', ";\n        line-height: ").concat(props.theme.components.stepper.lineHeight, ";\n    ");
});
export var StyledActual = styled.div(_templateObject3(), function (props) {
  return "\n        color: ".concat(props.theme.components.stepper.actualColor, ";\n        font-size: ").concat(props.theme.components.stepper.actualFontSize, ";\n    ");
});
export var StyledNext = styled.div(_templateObject4(), function (props) {
  return "\n        color: ".concat(props.theme.components.stepper.nextColor, ";\n        font-size: ").concat(props.theme.components.stepper.nextFontSize, ";\n        margin-top: -5px;\n    ");
});
export var StyledProgress = styled.div(_templateObject5(), function (props) {
  return "\n        border: 3px solid ".concat(props.theme.components.stepper.progressBorderColor, ";\n        border-radius: 50%;\n        height: 50px;\n        width: 50px;\n        margin-left: 10px;\n        position: relative;\n    ");
});
export var StyledSvg = styled.svg(_templateObject6());
export var StyledCircle = styled.circle(_templateObject7(), function (props) {
  return "\n        stroke-dasharray: ".concat(props.strokeDasharray, ";\n        stroke-dashoffset: ").concat(props.strokeDashoffset, ";\n        transform: rotate(-90deg);\n        transform-origin: 50% 50%;\n        transition: ").concat(props.theme.components.stepper.circleTransition, " stroke-dashoffset;\n    ");
});
export var StyledCircleMsg = styled.div(_templateObject8(), function (props) {
  return "\n        color: ".concat(props.theme.components.stepper.circleColor, ";\n        font-size: ").concat(props.theme.components.stepper.circleFontSize, ";\n        font-weight: ").concat(props.theme.components.stepper.circleFontWeight, ";\n        line-height: ").concat(props.theme.components.stepper.circleTextLineHeight, ";\n        margin-top: 14px;\n        text-align: center;\n    ");
});